import { Dispatcher } from 'flux';

module.exports = new Dispatcher();
